import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { PageProps} from "@/craftable-pro/Types/page";
import dayjs from "dayjs";

export function useClient() {
    const isClient = computed(() => (usePage().props as PageProps)?.auth.is_client);
    const client = computed(() => (usePage().props as PageProps)?.auth.client);
    const clientHasPlan = computed(() => (usePage().props as PageProps)?.auth.clientHasPlan);
    const clientSetupStatus = computed(() => (usePage().props as PageProps)?.auth.clientSetupStatus);

    const calculatedTrialEndDate = computed<dayjs.Dayjs | null>(() => {
        if (client.value?.is_trial && client.value.trial_expires_at) {
            const expiresAtDate = dayjs(client.value.trial_expires_at);
            if (expiresAtDate.isValid()) return expiresAtDate;
            else {
                console.error("Data 'client.trial_expires_at' inválida com dayjs:", client.value.trial_expires_at);
                return null;
            }
        }
        return null;
    });

    const currentBadgeState = computed<'freeTrial' | 'activePlan' | 'noPlan'>(() => {
        if (!isClient.value) return 'noPlan';

        const activeSubscriptionAndNotOnTrial = client.value.active_subscription && client.value.active_subscription.related_plan && !client.value.is_trial;
        if (!client.value) return 'noPlan';
        if (activeSubscriptionAndNotOnTrial || client.value?.subscription?.status === 'active') return 'activePlan';
        if (client.value.is_trial && calculatedTrialEndDate.value) return 'freeTrial';
        return 'noPlan';
    });


    const isPremiumUser = computed<boolean>(() => {
        return currentBadgeState.value === 'activePlan'
    });

    const isTrialUser = computed<boolean>(() => {
        return currentBadgeState.value === 'freeTrial'
    });


    return {
        client: client,
        isClient: isClient,
        clientHasPlan: clientHasPlan,
        clientSetupStatus: clientSetupStatus,
        calculatedTrialEndDate: calculatedTrialEndDate,
        currentBadgeState: currentBadgeState,
        isPremiumUser: isPremiumUser,
        isTrialUser: isTrialUser
    };
}
